trans.$inject = ['translator'];

export default function trans(translator) {
    return function (key, parameters, domain, locale) {
        return translator.trans(key, parameters, domain, locale);
    };
}
